import { render, staticRenderFns } from "./ModalTestSms.vue?vue&type=template&id=5bd38e6e&scoped=true&"
import script from "./ModalTestSms.vue?vue&type=script&lang=js&"
export * from "./ModalTestSms.vue?vue&type=script&lang=js&"
import style0 from "./ModalTestSms.vue?vue&type=style&index=0&id=5bd38e6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd38e6e",
  null
  
)

export default component.exports